import { createReducer, on } from '@ngrx/store';
import { Forecast } from '../../models/forecast.model';
import * as ForecastsActions from './forecasts.actions';

export interface ForecastsState {
  forecasts: Forecast[];
  selectedForecast: Forecast | null;
  loading: boolean;
  error: string | null;
}

export const initialState: ForecastsState = {
  forecasts: [],
  selectedForecast: null,
  loading: false,
  error: null,
};

export const forecastsReducer = createReducer(
  initialState,

  // Load Forecasts
  on(ForecastsActions.loadForecasts, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(ForecastsActions.loadForecastsSuccess, (state, { forecasts }) => ({
    ...state,
    forecasts,
    loading: false,
  })),

  on(ForecastsActions.loadForecastsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Load Single Forecast
  on(ForecastsActions.loadForecast, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(ForecastsActions.loadForecastSuccess, (state, { forecast }) => ({
    ...state,
    selectedForecast: forecast,
    loading: false,
  })),

  on(ForecastsActions.loadForecastFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Create Forecast
  on(ForecastsActions.createForecast, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(ForecastsActions.createForecastSuccess, (state, { forecast }) => ({
    ...state,
    forecasts: [...state.forecasts, forecast],
    loading: false,
  })),

  on(ForecastsActions.createForecastFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Update Forecast
  on(ForecastsActions.updateForecast, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(ForecastsActions.updateForecastSuccess, (state, { forecast }) => ({
    ...state,
    forecasts: state.forecasts.map((f) => (f.id === forecast.id ? forecast : f)),
    selectedForecast: forecast,
    loading: false,
  })),

  on(ForecastsActions.updateForecastFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Delete Forecast
  on(ForecastsActions.deleteForecast, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(ForecastsActions.deleteForecastSuccess, (state, { id }) => ({
    ...state,
    forecasts: state.forecasts.filter((f) => f.id !== id),
    loading: false,
  })),

  on(ForecastsActions.deleteForecastFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
